<section class="container">
  <div class="flex flex-row justify-between items-start mb-4">
    <rfc-heading-widget
      [headingName]="!isCaptive ? defineTitleAndDescriptionWidgetObj('welcome_alert') : defineTitleAndDescriptionWidgetObj('welcome_alert_captive')"></rfc-heading-widget>
  </div>

  <mat-card class="p-4 shadow-sm">
    <rfc-read-more [text]="getWelcomeAlertText()" [maxLength]="isMobile ? 100 : undefined"></rfc-read-more>
  </mat-card>

  <div class="flex flex-col-reverse md:flex-row justify-center items-center gap-[2em] mt-4 mb-4">
    <button mat-raised-button (click)="onSubmit()" class="ald-mat-button primary w-full md:w-auto">
      {{ "apply" | i18n }}
    </button>
  </div>
</section>